import { IConditionData } from './condition-data.interface';
import { WorkflowConditionTypes } from './Enums/workflow-condition-types';

/**
 * Représente la classe de base des données d'une condition.
 */
export class BaseConditionData implements IConditionData {
    /**
     * Id de la condition.
     */
    public id: number;

    /**
     * Nom de la condition.
     */
    public name: string;

    /**
     * Indique s'il s'agit de la condition principale.
     */
    public isMainCondition: boolean = false;

    /**
     * Constructeur.
     * @param type : Type de la condition.
     */
    constructor(public type: WorkflowConditionTypes) {}
}
